// src/components/MainLayout.jsx
import React, { useState, useEffect } from 'react'; // Adicionei useEffect aqui
import Navbar from './Navbar'; // Ajuste o caminho se necessário
import Sidebar from './Sidebar'; // Ajuste o caminho se necessário

// --- Hook useWindowSize ---
// (Pode ficar aqui ou em um arquivo separado: src/hooks/useWindowSize.js)
function useWindowSize() {
    const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined,
    });

    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        // Adiciona listener ao montar
        window.addEventListener("resize", handleResize);
        // Chama o handler imediatamente para pegar o tamanho inicial
        handleResize();
        // Remove o listener ao desmontar
        return () => window.removeEventListener("resize", handleResize);
    }, []); // Array vazio assegura que o efeito rode apenas na montagem/desmontagem

    return windowSize;
}
// --- Fim do Hook ---


// --- Componente MainLayout ---
const MainLayout = ({ children }) => {
    // Estado para controlar a abertura/fechamento do menu no MODO MOBILE
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    // Usa o hook para obter o tamanho da tela
    const size = useWindowSize();
    // Define o ponto de quebra para considerar 'mobile' (ajuste se necessário)
    const isMobile = size.width <= 768;

    // Função para alternar o estado do menu mobile (passada para a Navbar)
    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(prev => !prev); // Alterna o estado anterior
    };

    // Função para fechar o menu mobile (passada para a Sidebar, para fechar ao clicar no overlay ou item)
    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
    };

    return (
        <div style={layoutStyles.container}>
            {/* Renderiza a Navbar */}
            {/* Passa a função de toggle e a informação se é mobile */}
            <Navbar
                onToggleMobileMenu={toggleMobileMenu}
                isMobile={isMobile}
            />

            {/* Renderiza a Sidebar */}
            {/* Passa a informação se é mobile, se o menu mobile está aberto, e a função para fechar */}
            <Sidebar
                isMobile={isMobile}
                isMobileMenuOpen={isMobileMenuOpen}
                closeMobileMenu={closeMobileMenu}
            />

            {/* Área principal onde o conteúdo da página será renderizado */}
            <main style={{
                ...layoutStyles.mainContent,
                // Aplica margem à esquerda IGUAL À LARGURA DA SIDEBAR DESKTOP + PADDING,
                // somente quando NÃO FOR mobile (ou seja, desktop).
                marginLeft: !isMobile ? '240px' : '0', // IMPORTANTE: Ajuste '240px' para a largura exata definida na sua sidebar desktop no CSS!
                // Adiciona padding no topo para não ficar embaixo da Navbar fixa
                paddingTop: '65px' // IMPORTANTE: Ajuste '65px' para a altura exata da sua Navbar!
            }}>
                {/* children representa o componente da página atual (ex: <Home />, <Profile />, etc.) */}
                {children}
            </main>
        </div>
    );
};

// --- Estilos para o Layout ---
const layoutStyles = {
    container: {
        display: 'flex', // Organiza Sidebar e Conteúdo lado a lado (implicitamente)
        minHeight: '100vh', // Garante que o layout ocupe toda a altura da tela
        backgroundColor: '#f4f7f6', // Cor de fundo padrão para a área de conteúdo (opcional)
    },
    mainContent: {
        flexGrow: 1, // Faz a área de conteúdo ocupar todo o espaço restante
        padding: '20px', // Espaçamento interno padrão para o conteúdo das páginas
        transition: 'margin-left 0.3s ease-in-out', // Anima a mudança da margem no resize
        width: '100%', // Necessário para cálculo correto da largura com marginLeft
        boxSizing: 'border-box', // Garante que padding não aumente o tamanho total
        // paddingTop e marginLeft são aplicados dinamicamente via style prop acima
    },
};

export default MainLayout;